import { SET_USER_CASES, REMOVE_USER_CASES } from "../types";

export const setCases = (userCases) => ({
  type: SET_USER_CASES,
  userCases,
});

export const setUserCases = (userCases) => (dispatch) => {
  dispatch(setCases(userCases));
};

export const removeUserCases = () => ({
  type: REMOVE_USER_CASES,
});

export const resetUserCases = () => (dispatch) => {
  dispatch(removeUserCases());
};



// WEBPACK FOOTER //
// ./src/actions/userCases.js